import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../common/utils/base_error";
import { axiosInstance } from "../axiosInstance";

const apiKey = ""; 

// Implementação de retry com exponential backoff conforme boas práticas
const fetchWithRetry = async (url: string, options: any, retries = 5) => {
  const delays = [1000, 2000, 4000, 8000, 16000];
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(url, options);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      if (i === retries - 1) throw error;
      await new Promise(res => setTimeout(res, delays[i]));
    }
  }
};


export const sendMessageToAPI = async (perguntaDoUsuario: string, sessionId: string) => {
  try {
    const request = { 
        pergunta: perguntaDoUsuario,
        sessionId: sessionId 
    };
    
    const result = await axiosInstance({}).post(
      `/GenerativeAI/perguntar`, 
      request
    );

    const data = result.data;

    return { role: "assistant", content: data.resposta };

  } catch (error: unknown) {
    console.error("Erro ao comunicar com a IA:", error);
    
    if (typeof error === "string") {
      throw new Error(error);
    } else if (isBaseError(error)) {
      throw toBaseError(error);
    } else if (error instanceof AxiosError) {
      throw new Error(error.message);
    } else if (error instanceof Error) {
      throw error;
    } else {
      throw new Error("Falha ao executar requisição na IA!");
    }
  }
};